import React, { useEffect, useRef, useState } from "react";
import DrawDeck, { CANVAS_SIZE } from "./DrawDeck";
import { RadioGroup } from "@mui/material";
import DeckRadio from "./DeckRadio";
import { fixedState } from "./DecksState";

function DeckMaterial({ deckState, updateDeckState }) {
    const canvasRef = useRef(null);
    const textFields = useRef({});

    const { deckShape, deckRotation } = deckState.deckStructure;

    DrawDeck({
        canvasRef,
        textFields,
        deckShape,
        deckRotation,
        deckState,
        updateDeckState,
        hideText: false,
        hideGrid: true,
        showDeckLay: false,
    });

    return (
        <div
            style={{
                padding: 15,
                display: "flex",
                gap: "20px",
            }}
        >
            <canvas ref={canvasRef} width={CANVAS_SIZE} height={CANVAS_SIZE} />
            <div>
                <h3 style={{ padding: "20px 0px", margin: 0 }}>Joist spacing for flooring material</h3>
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                    }}
                >
                    <hr />
                    <DeckRadio
                        style={{ flexDirection: "column" }}
                        onChange={(e) => updateDeckState({ ...deckState, deckMaterial: e.target.value })}
                        value={deckState.deckMaterial}
                        fixedMap={fixedState.deckMaterial}
                    />
                </div>
            </div>
        </div>
    );
}

export default DeckMaterial;
